import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CssBaseline } from '@mui/material';
import { BrowserRouter, Route, Routes } from 'react-router';
import ChatPage from './routes/chat';
import HomePage from './routes/home';
import LoginPage from './routes/login';
import OutreachPage from './routes/outreach';
import SupportPage from './routes/support';
import { AuthProvider } from './hooks/useAuth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <AuthProvider>
    <React.StrictMode>
      <CssBaseline />
      <BrowserRouter>
          <Routes>
            <Route path='/login' element={<LoginPage />} />
            <Route path='/' element={<App />}>
              <Route index element={<HomePage />} />
              <Route path='chat' element={<ChatPage />} />
              <Route path='outreach' element={<OutreachPage />} />
              <Route path='support' element={<SupportPage />} />
            </Route>
          </Routes>
      </BrowserRouter>
    </React.StrictMode>
  </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
